var React       = require('react');

var QuizOptions = require('./quiz_options');
var Icon        = require('infl-icons').Icon;
var Actions     = require('../state');
var { withNamespaces } = require('react-i18next');

var Question = React.createClass({
  propTypes: {
    question: React.PropTypes.object.isRequired,
    id: React.PropTypes.string.isRequired,
    questionOrdinal: React.PropTypes.number.isRequired
  },

  render: function() {
    const { question, id, questionOrdinal, t } = this.props;

    return (
      <div className="c-question-container" style={{marginBottom: '40px'}}>
        <p className="c-question" style={this.styles.question}>
          <span className="c-question-num" style={this.styles.ordinal}>
            {questionOrdinal}.
          </span>
          {question.question}
        </p>
        <div className="c-points-container" style={this.styles.pointsCorrect}>
          <span className="c-icon-wrapper" style={this.styles.pointIcon}>
            <Icon icon="coins" />
          </span>
          <span className="c-points" style={this.styles.points}>
            {question.pointsCorrect}
          </span> {t('Points for answering correctly')}
        </div>
        <QuizOptions
          answers={question.answers}
          selectedAnswer={question.selectedAnswer}
          onChange={this._handleChange}
          correctAnswers={question.correctAnswers}
          id={id} />
      </div>
    );
  },

  _handleChange: function(event) {
    Actions.trigger("saveAnswer", this.props.id, event.target.value);
  },

  styles: {
    points: {
      fontSize: '20px'
    },
    pointIcon: {
      marginRight: '5px'
    },
    pointsCorrect: {
      marginTop: '3px',
      marginBottom: '15px'
    },
    question: {
      marginBottom: '0px'
    },
    ordinal: {
      float: 'left',
      fontWeight: 'bold',
      lineHeight: '1.62em',
      marginRight: '0.3em'
    }
  }
});

module.exports = withNamespaces()(Question);



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/components/question.jsx